import React from "react";

import { attributeToBoolean } from "@utils/attributes";

import Newsletter from "./newsletter.component";

export type NewsLetterContainerProps = {
    buttonText: string;
    helperText: string;
    isBold: boolean;
    alignment: string;
    link: string;
};

const NewsLetterContainer = ({
    buttonText,
    helperText,
    isBold,
    alignment,
    link,
}: NewsLetterContainerProps) => (
    <Newsletter
        buttonText={buttonText}
        helperText={helperText}
        alignment={alignment}
        isBold={attributeToBoolean(isBold)}
        link={link}
    />
);

export { NewsLetterContainer };
